module.exports = __webpack_public_path__ + "media/application/images/demo/menu-a1be01211a0e20d242f5f7eec298a2bb.jpg";